import React,{ useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';


const Review = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);

  const handleTouchStart = (e) => {
    setTouchStart(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const minSwipeDistance = 50;

    if (Math.abs(distance) < minSwipeDistance) return;

    if (distance > 0) {
      // Swiped left
      nextSlide();
    } else {
      // Swiped right
      prevSlide();
    }

    // Reset values
    setTouchStart(null);
    setTouchEnd(null);
  };

  const reviews = [
    {
      name: "Shamil Hussain",
      rating: 5,
      time: "a week ago",
      text: "I am extremely pleased with the outstanding service provided by Kasima Cap services. They made the entire process of obtaining my family visa and residence IDs smooth and efficient. From start to finish, every step was handled professionally and on time. What impressed me the most was their clear communication, attention to detail, and dedication to ensuring everything was completed without any issues.",
      thanks: "Thanks to their excellent work,",
      future: "I will definitely continue to work with them in the future.",
      special: "Special Thanks to Shaani"
    },
    {
      name: "Shamil Hussain",
      rating: 5,
      time: "a week ago",
      text: "I am extremely pleased with the outstanding service provided by Kasima Cap services. They made the entire process of obtaining my family visa and residence IDs smooth and efficient. From start to finish, every step was handled professionally and on time. What impressed me the most was their clear communication, attention to detail, and dedication to ensuring everything was completed without any issues.",
      thanks: "Thanks to their excellent work,",
      future: "I will definitely continue to work with them in the future.",
      special: "Special Thanks to Shaani"
    },
    // Add more reviews as needed
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === reviews.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? reviews.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="max-w-6xl mx-auto p-6 mt-[1000px] md:mt-[800px]">
      {/* Header */}
      <div className="absolute w-full md:w-[1046px] h-auto md:h-[287px] left-1/2 -translate-x-1/2 font-inter font-light text-[50px] md:text-[120px] leading-[60px] md:leading-[140px] flex items-center text-center tracking-[-2.24px] text-[#060000] px-4 md:px-0">
        <p>
          Trusted by <span className="font-semibold">200+</span> Dubai Residence
        </p>
      </div>

      {/* Carousel Container */}
      <div className="relative mt-[200px] md:mt-[350px] shadow-lg shadow-gray-500/50">
        {/* Navigation Buttons - Hide on mobile */}
        <button 
          onClick={prevSlide}
          className=" md:block absolute left-0 top-1/2 -translate-y-1/2 -translate-x-6 bg-white rounded-full p-2 shadow-lg z-10"
        >
          <ChevronLeft className="w-6 h-6 text-gray-600" />
        </button>
        
        <button 
          onClick={nextSlide}
          className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-6 bg-white rounded-full p-2 shadow-lg z-10"
        >
          <ChevronRight className="w-6 h-6 text-gray-600" />
        </button>

        {/* Carousel Content */}
        <div className="overflow-hidden"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div 
            className="flex transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {reviews.map((review, index) => (
              <div key={index} className="w-full flex-shrink-0 px-2 md:px-4">
                <div className="bg-white rounded-lg p-4 md:p-6">
                  <div className="flex items-center mb-4">
                    <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gray-200 mr-3 md:mr-4"></div>
                    <div>
                      <h3 className="font-semibold text-sm md:text-base">{review.name}</h3>
                      <div className="flex text-yellow-400 text-sm md:text-base">
                        {'★'.repeat(review.rating)}
                      </div>
                      <p className="text-gray-500 text-xs md:text-sm">{review.time}</p>
                    </div>
                  </div>
                  <p className="text-gray-700 mb-4 text-sm md:text-base">{review.text}</p>
                  <p className="text-gray-700 mb-2 text-sm md:text-base">{review.thanks}</p>
                  <p className="text-gray-700 mb-2 text-sm md:text-base">{review.future}</p>
                  <p className="text-gray-700 text-sm md:text-base">{review.special}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Dots Indicator */}
        <div className="flex justify-center mt-4 gap-2">
          {reviews.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`h-2 w-2 rounded-full transition-all ${
                currentIndex === index ? 'bg-blue-500 w-4' : 'bg-gray-300'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );

};
export default Review;